var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "video-border",
    style: {
      opacity: _vm.opacity
    },
    attrs: {
      "outlined": ""
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }